import PlaceInformation from '../../components/offlineLocation/PlaceInformation';
import EventInformation from '../../components/offlineLocation/EventInformation';
import FootprintSection from '../../components/offlineLocation/FootprintSection';
import LocationInformation from '../../components/offlineLocation/LocationInformation';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import type { Location } from '../../domain/models/locations/Location';
import dDayCalculate from '@pocapan/shared/utils/dDayCalculate';

const PlaceEventBox = ({ pos }: { pos: Location }) => {
  // 첫 번째 이벤트가 있을 때만 dDay 계산
  const firstEvent = pos.events[0];
  const _dDay =
    firstEvent && firstEvent.startDateString && firstEvent.endDateString
      ? dDayCalculate(firstEvent.startDateString, firstEvent.endDateString)
      : undefined;

  return (
    <>
      {/* 공간 정보 */}
      <PlaceInformation pos={pos} />
      <div
        className="mt-[14px] mb-[16px] border-b !border-separator-light-1 dark:!border-separator-dark-1"
        style={{ marginLeft: '-16px', marginRight: '-16px' }}
      />
      <div>
        {/* 이벤트 정보 */}
        <div className="flex flex-col">
          {pos.events.map((event, index) => (
            <div
              key={event.eventId}
              onClick={() => {
                openNewTab(`/locations/${pos.locationId}/events/${event.eventId}`);
              }}
            >
              <EventInformation event={event} siteType={pos.siteType} />
              {index < pos.events.length - 1 && (
                <div className="my-[12px] border border-solid !border-separator-light-1 dark:!border-separator-dark-1" />
              )}
            </div>
          ))}
        </div>

        {/* 트위터 정보 */}
        {(pos.externalSources.length > 0 || pos.footprints.length > 0) &&
          pos.events.length === 0 && <FootprintSection pos={pos} />}
        {/* 장소 정보 (이벤트, 트위터 정보가 모두 없을 경우) */}
        {pos.events.length === 0 &&
          pos.externalSources.length === 0 &&
          pos.footprints.length === 0 && <LocationInformation pos={pos} />}
      </div>
    </>
  );
};

export default PlaceEventBox;

